import { render, staticRenderFns } from "./order_list.vue?vue&type=template&id=4eb73304&scoped=true"
import script from "./order_list.vue?vue&type=script&lang=js"
export * from "./order_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb73304",
  null
  
)

export default component.exports